export default __webpack_public_path__ + "static/media/banner11.bf692a97.jpg";